import {TimelineEntry} from './TimelineEntry';

export class TimelineLeftQueueEntry extends TimelineEntry {

    constructor(public key: string, public startDate: Date) {
        super(key, 'Left', startDate, true);
    }

    getColor(): string {
        return '#DD0000';
    }

}
